import {lazy} from "react";

export const VoyageTemplatePlanningLazy = lazy(() => import('./VoyageTemplatePlanning'))
